var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ButtonToggleCollapse --global-clickable"},[_c('svgicon',{staticClass:"buttonToggleCollapseIcon",class:{ collapsed: _vm.collapsed },style:({ fill: _vm.fill }),attrs:{"icon":"chevron-down"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }